// @flow
import TrusteeReceiptReport from './TrusteeReceiptReport'
export default () => ({
  path: 'trustee-receipt-report',
  element: <TrusteeReceiptReport />,
})
